import GoodHabitGame from "../../components/Nursery/GeneralAwareness/ChooseCorrectHabbit";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


//document.title = "Mamas Guidance - Nursery - General Awareness - Good Habit & Bad Habit"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/good-bad-habbit/choose-correct", title: "Pick the Good Habit", component: GoodHabitGame}
];


export default topics;